const DATABASE_NAME = 'ticklegram-outbox';
const DATABASE_VERSION = 1;
const STORE_NAME = 'text_messages';

const openDatabase = () => new Promise((resolve, reject) => {
  if (!('indexedDB' in window)) {
    reject(new Error('IndexedDB is not available in this browser'));
    return;
  }
  const request = window.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
  request.onerror = () => reject(request.error);
  request.onsuccess = () => resolve(request.result);
  request.onupgradeneeded = () => {
    const database = request.result;
    if (!database.objectStoreNames.contains(STORE_NAME)) {
      const store = database.createObjectStore(STORE_NAME, { keyPath: 'id' });
      store.createIndex('user_id', 'user_id', { unique: false });
      store.createIndex('chat_id', 'chat_id', { unique: false });
      store.createIndex('created_at', 'created_at', { unique: false });
    }
  };
});

const runTransaction = async (mode, callback) => {
  const database = await openDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, mode);
      const store = transaction.objectStore(STORE_NAME);
      let result;
      transaction.oncomplete = () => resolve(result);
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error || new Error('IndexedDB transaction aborted'));
      result = callback(store);
    });
  } finally {
    database.close();
  }
};

export const saveQueuedTextMessage = (message) => runTransaction('readwrite', (store) => {
  store.put(message);
});

export const deleteQueuedTextMessage = (id) => runTransaction('readwrite', (store) => {
  store.delete(id);
});

export const listQueuedTextMessages = async (userId) => {
  const database = await openDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, 'readonly');
      const index = transaction.objectStore(STORE_NAME).index('user_id');
      const request = index.getAll(String(userId));
      request.onsuccess = () => resolve(
        (request.result || []).sort((left, right) => String(left.created_at).localeCompare(String(right.created_at)))
      );
      request.onerror = () => reject(request.error);
    });
  } finally {
    database.close();
  }
};

export const createQueuedTextMessage = ({ userId, chatId, platform, content, options = {} }) => {
  const id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const createdAt = new Date().toISOString();
  return {
    id,
    user_id: String(userId),
    chat_id: String(chatId),
    platform,
    content,
    options,
    status: 'queued',
    attempts: 0,
    last_error: null,
    created_at: createdAt,
    updated_at: createdAt,
  };
};
